import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=3577ddcb"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=3577ddcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports